const mapping: Record<string, string> = {
  jobId: 'l=>l.JobId',
  jobStatus: 'l=>l.JobStatus',
  jobTargetMethod: 'l=>l.JobTargetMethod',
  jobCreationDate: 'l=>l.JobCreationDate',
  jobExpirationDate: 'l=>l.JobExpirationDate',
}

export const mapSortJobParam = (key: string) => mapping[key]
